import { AuthState } from "@dis/auth";
import {
  LayoutState,
  TableState,
  QuotesState,
  ProjectsState,
  JobsState,
  BuildsState,
  AssembliesState,
  ComponentsState,
  PartsState,
} from "@dis/shared";
import { withNgxsReduxDevtoolsPlugin } from "@ngxs/devtools-plugin";
import { withNgxsFormPlugin } from "@ngxs/form-plugin";
import { withNgxsRouterPlugin } from "@ngxs/router-plugin";
import { withNgxsStoragePlugin } from "@ngxs/storage-plugin";
import { provideStore } from "@ngxs/store";
import { NGXS_APP_STORAGE_CONFIG } from "./ngxs-storage-config";

export function provideNgxsCore() {
  return [
    provideStore(
      [
        AuthState,
        /**
         * App Context related states
         */
        LayoutState,
        TableState,
        /**
         * JTMS Collection States
         */
        QuotesState, //TODO: confirm if this is still needed, should be moved to dataconnect
        ProjectsState, //TODO: confirm if this is still needed, should be moved to dataconnect
        JobsState, //TODO: confirm if this is still needed, should be moved to dataconnect
        BuildsState, //TODO: confirm if this is still needed, should be moved to dataconnect
        AssembliesState,
        ComponentsState, // TODO: delete me: Sheets-backed; remove once no consumers remain and the PO Sheets append is gone.
        PartsState,
        // ContainersState, //TODO: delete me, Should be completelly moved to dataconnect
        // InvoicesState, //TODO: delete me, Should be completelly moved to dataconnect
      ],
      withNgxsStoragePlugin(NGXS_APP_STORAGE_CONFIG),
      withNgxsRouterPlugin(),
      withNgxsFormPlugin(),
      withNgxsReduxDevtoolsPlugin()
    ),
  ];
}
